import Vue from 'vue'
import './plugins/fontawesome'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';

import core from '@/core/Core';
core.setRouter(router);
global.core = core;

import './assets/global.scss'

// import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/dist/css/swiper.css'

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)
const i18n = new VueI18n({
    locale: localStorage.getItem('us_locale') === null ? 'de' : localStorage.getItem('us_locale'),
    messages: require('@/assets/dictionary/localization').default,
})


Vue.config.productionTip = false

new Vue({
  // VueAwesomeSwiper,
  router,
  i18n,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
